import React from "react";

const XilaPresentation = () => {
  return (
    <div id="xilaPresentation" className="marginApp">
      <h1>
        Bonjour, je m'appelle xila.
        <br />
        Je fais du bricolage avec de l'image et du texte.
      </h1>
    </div>
  );
};

export default XilaPresentation;
